import { render, staticRenderFns } from "./aboutMe.vue?vue&type=template&id=5d9fced2&scoped=true"
import script from "./aboutMe.vue?vue&type=script&lang=js"
export * from "./aboutMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9fced2",
  null
  
)

export default component.exports